export const getView = state => state.editor.view;
export const getAssetUid = state => state.editor.assetUid;
export const getColumnBaseUid = state => state.editor.columnBaseUid;
export const getQuery = state => state.editor.query;
